import { jsx as s } from "react/jsx-runtime";
import { c as t } from "../index-rKuIKazb.js";
import { useTheme as o } from "../ThemeProvider/index.js";
import '../assets/index22.css';const r = "_layout_6m4yz_2", i = "_spinner_6m4yz_9", c = "_spin_6m4yz_9", l = "_dark_6m4yz_20", e = {
  layout: r,
  spinner: i,
  spin: c,
  dark: l
}, _ = ({ className: a = "" }) => {
  const n = o();
  return /* @__PURE__ */ s("div", { className: t(e[n], e.layout, a), children: /* @__PURE__ */ s(
    "svg",
    {
      className: e.spinner,
      "data-aaa": "loadingSpinner",
      viewBox: "0 0 1024 1024",
      focusable: "false",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" })
    }
  ) });
};
export {
  _ as default
};
